import { useEffect, useState } from 'react'

import {
  Grid,
  Box,
  TextField,
  InputAdornment,
  Button,
  CircularProgress,
} from '@mui/material'

import './signup.css'

import AlternateEmailIcon from '@mui/icons-material/AlternateEmail'
import MailIcon from '@mui/icons-material/Mail'
import logo from '../../../assets/Altigen_logo_with_text.png'
import { useNavigate, useSearchParams } from 'react-router-dom'
import { checkSubdomain, companySignup } from '../../../api/post/postApi'

import VisibilityOffIcon from '@mui/icons-material/VisibilityOff'
import VisibilitySharpIcon from '@mui/icons-material/VisibilitySharp'
// email validator
import validator from 'validator'
import LoadingSection from '../../../common/components/loaders/loader'
import {
  normalizeApiResponse,
  requiredLabel,
  saveToken,
} from '../../../helpers/HelperFunctions'
import {
  COMPANY_LEVELS,
  COMPANY_STATUS,
  PASSWORD_PATTERN,
} from '../../../helpers/Constants'
import Carousel from '../../../common/components/carousel/Carousel'
import { useToastContext } from '../../../App'
import { PATTERNS } from '../../../helpers/constants/ValidationPatterns'
import PasswordValidator from '../../../common/components/custom/password-validator/PasswordValidator'

function Signup(props) {
  const { toast } = useToastContext()
  const navigate = useNavigate()
  useEffect(() => {
    findcompany()
  }, [])

  const [parentId, setparentId] = useState('')
  const [domain, setdomain] = useState('')
  const [companyLevel, setcompanyLevel] = useState('')
  const [companyid, setcompanyid] = useState('')
  const [companyName, setcompanyName] = useState('')
  const [isShowPassword, setShowPassword] = useState(false)
  const [isShowConfirmPassword, setShowConfirmPassword] = useState(false)

  // helper to set company details
const setCompanyData = (result) => {
  setcompanyName(result.companyName)
  localStorage.setItem('companyname', result.companyName)
  setcompanyLevel(result.companyLevel)
  setparentId(result.parentId)
  setcompanyid(result.companyId)
  setdomain(result.subDomain)
}

// helper to handle company status
const handleCompanyStatus = (status) => {
  const redirectStatuses = [
    COMPANY_STATUS.Active,
    COMPANY_STATUS.Draft,
    COMPANY_STATUS.Rejected,
    COMPANY_STATUS.ApprovalPending,
  ]
  if (redirectStatuses.includes(status)) {
    navigate('/login')
  }
}

  const findcompany = async () => {
    setPageLoader(true)
      const url = { fullUrl: window.location.href }

    try {
      const data = await checkSubdomain(url)
      if (!data) return
      setPageLoader(false)
      const result = data.data.result
    setCompanyData(result)
    handleCompanyStatus(result.COMPANY_STATUS)
    } catch (error) {
      setPageLoader(false)
      toast.showToast(normalizeApiResponse(error)?.message, 'error')
      navigate('/login')
    }
  }
  // preloader hooks
  const [loader, setloader] = useState(false)
  const [pageLoader, setPageLoader] = useState(false)
  const [searchParams] = useSearchParams()

  // sign up hooks
  const [signup, setsignup] = useState({
    companyname: '',
    email: searchParams.get('email') || '',
    password: '',
  })

  const signuphandler = (e) => {
    const data = { ...signup }
    data[e.target.id] = e.target.value
    setsignup(data)
  }

  const handlerConfirmPassword = (e) => {
    const data = { ...signup }
    data[e.target.id] = e.target.value
    setsignup(data)

    validateConfirmPassword(e.target.value, setemptyconfirmpasswordhelpertext)
  }

  const [password, setpassword] = useState(null)

  const [emailhelpertext, setemailhelpertext] = useState('')
  const [companyhelpertext, setcompanyhelpertext] = useState('')
  const [passwordhelpertext, setpasswordhelpertext] = useState('')
  const [emptypasswordhelpertext, setemptypasswordhelpertext] = useState('')
  const [emptyconfirmpasswordhelpertext, setemptyconfirmpasswordhelpertext] =
    useState('')

    
  // --- Validation helpers ---
const isValidEmail = (email, setHelper) => {
  if (!validator.isEmail(email)) {
    setHelper('Please enter a valid email')
    return false
  }
  setHelper('')
  return true
}
const isValidCompanyName = (name, setHelper) => {
  if (!name) {
    setHelper('Please enter your company name')
    return false
  }
  setHelper('')
  return true
}
const isValidPasswordInput = (password, signupPassword, setPasswordHelper, setConfirmHelper) => {
  if (!password) {
    setPasswordHelper('Please enter password')
    return false
  }
  if (!PASSWORD_PATTERN.test(password)) {
    setPasswordHelper(
      'Must Contain 8 Characters, One Lowercase, One Number and One Special Case Character'
    )
    return false
  }
  if (signupPassword && password !== signupPassword) {
    setConfirmHelper('Password should be same')
    return false
  }
  setPasswordHelper('')
  setConfirmHelper('')
  return true
}
const isValidConfirmPasswordInput = (confirmPassword, password, setHelper) => {
  if (!confirmPassword) {
    setHelper('Confirm password should not be empty')
    return false
  }
  if (!PASSWORD_PATTERN.test(confirmPassword)) {
    setHelper(
      'Must Contain 8 Characters, One Lowercase, One Number and One Special Case Character'
    )
    return false
  }
  if (confirmPassword !== password) {
    setHelper('Password should be the same')
    return false
  }
  setHelper('')
  return true
}

 const proceedSignup = async () => {
    setloader(true)
    const data = {
      parentId,
      companyId: companyid,
      email: signup.email,
      password: signup.password,
      // companyName:signup.companyname,
      companyName,
      domain,
      companyLevel,
    }
    try {
      const res = await companySignup(data)
      if (!res) return
        localStorage.setItem('email', data.email)
        setloader(false)
            const { companyStatus, companyId: cid } = res.data.result.companyInfo

        const datamodal = res.data.result.companyInfo
        if (companyStatus == COMPANY_STATUS.Draft) {
          saveToken(res.data.result.token)
          localStorage.setItem('companyid', cid )
          navigate('/signup-stepper')
        }
    } catch (error) {
      setloader(false)
      toast.showToast(
        normalizeApiResponse(error)?.message,
        'error'
      )
    }
  }

  // create account function
  const createAccount = () => {
    const emailOk = isValidEmail(signup.email, setemailhelpertext)
  const companyOk = isValidCompanyName(companyName, setcompanyhelpertext)
  const passwordOk = isValidPasswordInput(password, signup.password, setemptypasswordhelpertext, setemptyconfirmpasswordhelpertext)
  const confirmOk = isValidConfirmPasswordInput(signup.password, password, setemptyconfirmpasswordhelpertext)
    if (![emailOk, companyOk, passwordOk, confirmOk].every(Boolean)) return

  if (!PATTERNS.PASSWORD.test(password) || !PATTERNS.PASSWORD.test(signup.password)) {
    toast.showToast('Please enter valid password', 'error')
    return
  }

  proceedSignup()
    
  }

  const [passwordtype, setpasswordtype] = useState(false)

  const handlePasswordShow = () => {
    setShowPassword(!isShowPassword)
  }
  const handleShowConfirmPassword = () => {
    setShowConfirmPassword(!isShowConfirmPassword)
  }

  const ChangePasswordValidation = (e) => {
    const newPassword = e.target.value
    setpassword(newPassword)
    validatePassword(newPassword, setemptypasswordhelpertext)
  }

  const validatePassword = (password, setemptypasswordhelpertext) => {
    if (password === '') {
      setemptypasswordhelpertext('Please enter password')
      return false
    } else if (!PASSWORD_PATTERN.test(password)) {
      setemptypasswordhelpertext(
        'Must Contain 8 Characters, One Lowercase, One Number and One Special Case Character'
      )
      return false
    } else if (signup.password !== '' && password !== signup.password) {
      setemptyconfirmpasswordhelpertext('password should be same')
      return false
    }
    setemptypasswordhelpertext('')
    setemptyconfirmpasswordhelpertext('')
    return true
  }

  const validateConfirmPassword = (confirmPassword, setEmptyHelperText) => {
    if (confirmPassword === '') {
      setEmptyHelperText('Confirm password should not be empty')
      return false
    } else if (!PASSWORD_PATTERN.test(confirmPassword)) {
      setEmptyHelperText(
        'Password must match'
      )
      return false
    } else if (password !== confirmPassword) {
      setEmptyHelperText('password should be the same')
      return false
    }
    setEmptyHelperText('')
    return true
  }

  const signupForm = () => {
    return (
      <Box className="Main-container">
                <Box className="Reseller-signup-main-form-container">
                  <Box className="reseller-signup-container1">
                    <img
                      src={logo}
                      width="250px"
                      alt="logo"
                      style={{ objectFit: 'cover' }}
                    />
                  </Box>

                  <Box className="reseller-signup-container2">
                    <span>
                      Sign Up For a
                      <br />
                      {companyLevel == COMPANY_LEVELS.serviceprovider
                        && 'Service Provider'}
                      {companyLevel == COMPANY_LEVELS.reseller
                        && 'Reseller'}
                      {companyLevel == COMPANY_LEVELS.customer
                        && 'Customer'}
                    </span>
                  </Box>

                  <Box className="reseller-signup-container3">
                    {requiredLabel('Company Name')}
                    <TextField
                      helperText={companyhelpertext}
                      error={companyhelpertext !== ''}
                      id="companyname"
                      value={companyName}
                      disabled
                      onChange={(e) => setcompanyName(e.target.value)}
                      // onChange={(e) => signuphandler(e)}
                      variant="outlined"
                      size="small"
                      fullWidth
                      InputProps={{
                        // readOnly: true,
                        style: {
                          height: '30px',
                        },
                        endAdornment: (
                          <InputAdornment position="end">
                            <AlternateEmailIcon className="textfield-iconStyle" />
                          </InputAdornment>
                        ),
                      }}
                    />
                    {requiredLabel('Email')}
                    <TextField
                      helperText={emailhelpertext}
                      error={emailhelpertext != '' ? true : false}
                      id="email"
                      onChange={(e) => signuphandler(e)}
                      variant="outlined"
                      size="small"
                      value={signup.email}
                      fullWidth
                      disabled={searchParams.get('email')}
                      InputProps={{
                        style: {
                          height: '30px',
                        },
                        endAdornment: (
                          <InputAdornment position="end">
                            <MailIcon className="textfield-iconStyle" />
                          </InputAdornment>
                        ),
                      }}
                    />
                    {requiredLabel('Password')}
                    <TextField
                      // helperText={emptypasswordhelpertext}
                      error={emptypasswordhelpertext != '' ? true : false}
                      onChange={(e) => ChangePasswordValidation(e)}
                      type={isShowPassword ? 'text' : 'password'}
                      variant="outlined"
                      size="small"
                      fullWidth
                      InputProps={{
                        style: {
                          height: '30px',
                        },
                        endAdornment: (
                          <InputAdornment
                            className="cursorStyle_pointer"
                            onClick={handlePasswordShow}
                            position="end"
                          >
                            {isShowPassword ? (
                              <VisibilitySharpIcon />
                            ) : (
                              <VisibilityOffIcon />
                            )}
                          </InputAdornment>
                        ),
                      }}
                    />
                    <PasswordValidator
                      password={password}
                      isTouched={password == ''}
                    />
                    {requiredLabel('Confirm Password')}
                    <TextField
                      helperText={
                        emptyconfirmpasswordhelpertext
                          ? emptyconfirmpasswordhelpertext
                          : passwordhelpertext
                            ? passwordhelpertext
                            : null
                      }
                      error={
                        emptyconfirmpasswordhelpertext != ''
                          ? true
                          : passwordhelpertext != ''
                            ? true
                            : false
                      }
                      onChange={(e) => handlerConfirmPassword(e)}
                      id="password"
                      variant="outlined"
                      fullWidth
                      size="small"
                      type={isShowConfirmPassword ? 'text' : 'password'}
                      InputProps={{
                        style: {
                          height: '30px',
                        },
                        endAdornment: (
                          <InputAdornment
                            className="cursorStyle_pointer"
                            onClick={handleShowConfirmPassword}
                            position="end"
                          >
                            {isShowConfirmPassword ? (
                              <VisibilitySharpIcon />
                            ) : (
                              <VisibilityOffIcon />
                            )}
                          </InputAdornment>
                        ),
                      }}
                    />
                  </Box>
                  <Box className="reseller-signup-container4">
                    <Button
                      variant="contained"
                      disableFocusRipple
                      fullWidth
                      sx={{
                        height: '55px',
                        borderRadius: '8px',
                        //fontSize: '14px',
                        letterSpacing: '1.5px',
                      }}
                      size="large"
                      onClick={createAccount}
                    >
                      create account &emsp;{' '}
                      {loader ? (
                        <CircularProgress size={20} sx={{ color: '#fff' }} />
                      ) : null}
                    </Button>
                  </Box>
                </Box>
              </Box>
    )
  }


  return (
    <div>
      <Grid container>
        {/* spliting in to 2 halfs */}
        {pageLoader && 
          <LoadingSection />
         }
         {!pageLoader && (
          <>
            <Grid item md={7} sm={7} xs={12}>
              <Box
                sx={{
                  borderRadius: '20px',
                  margin: '15px',
                  backgroundColor: '#0984E3',
                  height: '96vh',
                  width: '80%',
                }}
              >
                <Carousel />
              </Box>
            </Grid>
            <Grid item md={5} sm={5} xs={12}>
              {signupForm()}
            </Grid>
          </>
        )}
      </Grid>
    </div>
  )
}

export default Signup
